import { notification } from 'antd'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as promotionProviders from 'services/promotion'
import actions from './actions'

export function* SHOW_PROMOTION({ payload }) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })
  const response = yield call(promotionProviders.showPromotions, payload.businessCode)
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        promotionList: response.promotions,
      },
    })
  }

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
    },
  })
}

export function* UPDATE_PROMOTION_STATUS({ payload }) {
  const { businessCode } = payload

  const response = yield call(promotionProviders.updatePromotionStatus, payload)
  if (response) {
    yield put({
      type: actions.SHOW_PROMOTION,
      payload: {
        businessCode,
      },
    })
    notification.success({
      message: `Custom Rewards`,
      description: response.message,
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      error: !response,
    },
  })
}

export function* CREATE_PROMOTION({ payload }) {
  const { businessCode } = payload

  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: true,
    },
  })

  const response = yield call(promotionProviders.createPromotion, payload)
  if (response) {
    yield put({
      type: actions.SHOW_PROMOTION,
      payload: {
        businessCode,
      },
    })
    notification.success({
      message: `Custom Rewards`,
      description: response.message,
    })
  }
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: false,
      error: !response,
    },
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SHOW_PROMOTION, SHOW_PROMOTION),
    takeEvery(actions.CREATE_PROMOTION, CREATE_PROMOTION),
    takeEvery(actions.UPDATE_PROMOTION_STATUS, UPDATE_PROMOTION_STATUS),
  ])
}
